import { kioskApi } from '../axios.js';
export const kioskInstanceApi = {
    /**
     * Get all kiosk instances
     */
    getAllKioskInstances: () => kioskApi.get('/kiosk-instances'),
    /**
     * Get kiosk instances by shop ID
     */
    getKioskInstancesByShop: (shopId) => kioskApi.get('/kiosk-instances', { params: { shop_id: shopId } }),
    /**
     * Create a new kiosk instance
     */
    createKioskInstance: (data) => kioskApi.post('/kiosk-instances', data),
    /**
     * Get kiosk instance by join code
     */
    getKioskInstanceByCode: (joinCode) => kioskApi.get(`/kiosk-instances/code/${encodeURIComponent(joinCode)}`),
    /**
     * Update kiosk instance config
     */
    updateKioskInstanceConfig: (joinCode, config) => kioskApi.patch(`/kiosk-instances/code/${encodeURIComponent(joinCode)}/config`, { config }),
    /**
     * Update kiosk instance status
     */
    updateKioskInstanceStatus: (joinCode, status) => kioskApi.patch(`/kiosk-instances/code/${encodeURIComponent(joinCode)}/status`, { status }),
    /**
     * Delete a kiosk instance by join code
     */
    deleteKioskInstance: (joinCode) => kioskApi.delete(`/kiosk-instances/code/${encodeURIComponent(joinCode)}`),
    /**
     * Bulk delete all kiosk instances
     * @returns Object containing count of deleted instances and operation status
     */
    bulkDeleteAllInstances: () => kioskApi.delete('/kiosk-instances/bulk-delete')
};
